import axios from "axios";

// Con CRA + proxy => baseURL vacío (usa mismo host del front: http://localhost:3000)
// Sin proxy, puedes setear REACT_APP_API_BASE_URL=http://localhost:8000
const baseURL = process.env.REACT_APP_API_BASE_URL || "";

export const publicApi = axios.create({
	baseURL,
	withCredentials: true, // ✅ para enviar/recibir cookie refresh_token
	xsrfCookieName: "csrftoken", // ✅ Protección CSRF (Django default)
	xsrfHeaderName: "X-CSRFToken",
});

export const api = axios.create({
	baseURL,
	withCredentials: true,
	xsrfCookieName: "csrftoken", // ✅ Protección CSRF (Django default)
	xsrfHeaderName: "X-CSRFToken",
});

function syncServerTimeZone(headers) {
	if (!headers || typeof headers !== "object") return;

	const serverTimeZone = headers["x-server-timezone"];
	if (typeof serverTimeZone !== "string") return;

	const normalized = serverTimeZone.trim();
	if (!normalized) return;

	localStorage.setItem("somnus_server_tz", normalized);
}

let accessToken = null;
let onAuthUpdate = null;

export function setAccessToken(token) {
	accessToken = token;
}

export function setOnAuthUpdate(fn) {
	onAuthUpdate = fn; // (access, activeRole) => void
}

api.interceptors.request.use((config) => {
	if (accessToken) {
		config.headers = config.headers || {};
		config.headers.Authorization = `Bearer ${accessToken}`;
	}
	return config;
});

publicApi.interceptors.response.use(
	(res) => {
		syncServerTimeZone(res?.headers);
		return res;
	},
	(error) => {
		syncServerTimeZone(error?.response?.headers);
		return Promise.reject(error);
	},
);

let refreshPromise = null;

api.interceptors.response.use(
	(res) => {
		syncServerTimeZone(res?.headers);
		return res;
	},
	async (error) => {
		syncServerTimeZone(error?.response?.headers);

		const original = error.config;

		// Evita loops infinitos
		if (!original || original._retry) {
			return Promise.reject(error);
		}

		// Solo intentamos refresh si fue 401 (token expirado)
		if (error.response?.status !== 401) {
			return Promise.reject(error);
		}

		original._retry = true;

		try {
			if (!refreshPromise) {
				refreshPromise = publicApi.post("/api/auth/refresh/", {});
			}

			const refreshRes = await refreshPromise;
			refreshPromise = null;

			const newAccess = refreshRes.data.access;

			const activeRole = refreshRes.data.active_role || refreshRes.data.activeRole;

			setAccessToken(newAccess);

			// Avisar a AuthContext (si está conectado)
			if (onAuthUpdate) onAuthUpdate(newAccess, activeRole);

			// Reintentar request original con token nuevo
			original.headers = original.headers || {};
			original.headers.Authorization = `Bearer ${newAccess}`;

			return api(original);
		} catch (e) {
			refreshPromise = null;
			setAccessToken(null);
			if (onAuthUpdate) onAuthUpdate(null, null);
			return Promise.reject(e);
		}
	}
);